export default {
  heading: {
    cardCount: '1',
    widgetID: '107',
    widgetName: 'Bigpay Services Widget',
    widgetWidth: '1',
    layoutName: 'product_gallery_widget',
    headline: "",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Promotions | Bigpay Popular Destination`,
      eventLabelCardClick: `Bigpay Popular Destination  | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Bigpay Popular Destination | headline | {{headline}}`,
      eventLabelView: `Bigpay Popular Destination`,
    },
  },

  data: [
    {
      image: 'https://www.airasia.com/aa/bigpay/images/kuala-lumpur.png',
      primaryLabel: '',
      title: 'Kuala Lumpur',
      url: 'https://www.airasia.com/flights/kuala-lumpur-selangor'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/bangkok.png',
      primaryLabel: '',
      title: 'Bangkok',
      url: 'https://www.airasia.com/flights/from-kuala-lumpur-kul-to-bangkok-dmk'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/singapore.png',
      primaryLabel: '',
      title: 'Singapore',
      url: 'https://www.airasia.com/flights/singapore'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/penang.png',
      primaryLabel: '',
      title: 'Penang',
      url: 'https://www.airasia.com/flights/penang-malaysia'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/kota-kinabalu.png',
      primaryLabel: '',
      title: 'Kota Kinabalu',
      url: 'https://www.airasia.com/flights/kota-kinabalu-sabah'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/kuching.png',
      primaryLabel: '',
      title: 'Kuching',
      url: 'https://www.airasia.com/flights/kuching-sarawak'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/langkawi.png',
      primaryLabel: '',
      title: 'Langkawi',
      url: 'https://www.airasia.com/flights/langkawi-kedah'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/kota-bharu.png',
      primaryLabel: '',
      title: 'Kota Bharu',
      url: 'https://www.airasia.com/flights/kota-bharu-kelantan'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/sibu.png',
      primaryLabel: '',
      title: 'Sibu',
      url: 'https://www.airasia.com/flights/sibu-sarawak'
    },
    {
      image: 'https://www.airasia.com/aa/bigpay/images/johor-bahru.png',
      primaryLabel: '',
      title: 'Johor Bahru',
      url: 'https://www.airasia.com/flights/johor-bahru-johor'
    }
  ]
}